import { Context } from './context';
import { usePopover } from './hooks/usePopover';

import type { PopoverProps } from '@mui/material';
import type { FC, ReactNode } from 'react';

export interface PopoverProviderProps extends Omit<PopoverProps, 'open'> {
  children: ReactNode;
}

/**
 * provides context for controlling the Menu State
 * requires a <PopperToggle> to consume the toggle handler
 * requires a <PopoverDisplay> to consume event handler
 *
 * @example
 * ```jsx
 *   <PopperProvider>
 *     <PopperToggle>
 *       ...
 *     </PopperToggle>
 *     <PopoverDisplay>
 *       ...
 *     </PopoverDisplay>
 *   </PopperProvider>
 * ```
 */

export const PopoverProvider: FC<PopoverProviderProps> = ({
  children,
  ...props
}) => {
  const popper = usePopover({ id: 'popover' });

  const state = {
    ...popper,
    ...props,
  };

  return <Context.Provider value={state}>{children}</Context.Provider>;
};
